import { render } from "./AboutAccords.vue?vue&type=template&id=c18a04a4&scoped=true"
const script = {}

import "./AboutAccords.vue?vue&type=style&index=0&id=c18a04a4&scoped=true&lang=css"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c18a04a4"]])

export default __exports__